import React, { Fragment } from 'react'

import { useRouter } from 'next/router'

// third party components
import { Menu, Transition } from '@headlessui/react'

// images and icons
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'

// styles
import styles from './index.module.scss'
import MerchMenuPage from '../MerchMenuPage'

interface MenuEditProps {
  newProductURL: any
  isCreatedMerch: boolean
  setOpenShareModal: any
  editStoreSettings: any
}

const MenuShareMerch = ({ newProductURL, isCreatedMerch, setOpenShareModal, editStoreSettings }: MenuEditProps) => {
  const router = useRouter()
  return (
    <div className="relative flex items-center">
      <Menu>
        <Menu.Button>
          <div className={`${styles.iconContainer} w-[30px] h-[30px]`}>
            <ThreeDotIcon alt="" />
          </div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Item>
            {({ active }) => (
              <div>
                <MerchMenuPage
                  isOwn={isCreatedMerch}
                  setOpenShareModal={setOpenShareModal}
                  editStoreSettings={editStoreSettings}
                  addMerchItem={() => {
                    router.push(newProductURL)
                  }}
                />
              </div>
            )}
          </Menu.Item>
          {/* <Menu.Items className={styles.menuArea}>
            {isCreatedMerch && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    className={`${styles.menuItem} mb-[15px]`}
                    onClick={() => {
                      router.push(newProductURL)
                    }}
                  >
                    <AddProductIcon alt="" />
                    Add Product
                  </div>
                )}
              </Menu.Item>
            )}

            <Menu.Item>
              {({ active }) => (
                <div
                  className={`${styles.menuItem} mb-[15px]`}
                  onClick={() => {
                    setOpenShareModal(true)
                  }}
                >
                  <ShareSmallIcon alt="" />
                  Share Store
                </div>
              )}
            </Menu.Item>

            
            {isCreatedMerch && (
              <Menu.Item>
                {({ active }) => (
                  <div
                    className={`${styles.menuItem} mt-[15px]`}
                    onClick={() => {
                      router.push('/merch-logs')
                    }}
                  >
                    <SettingsIcon alt="" />
                    Store Settings
                  </div>
                )}
              </Menu.Item>
            )}
          </Menu.Items> */}
        </Transition>
      </Menu>
    </div>
  )
}

export default MenuShareMerch
